import type { RouterOutputs } from "~/utils/trpc";

export type CardType = RouterOutputs["card"]["search"]["cards"][0];
export type MinimalCardType = RouterOutputs["card"]["searchAll"][0];
export type EnrichedCardType = RouterOutputs["card"]["getBySlug"];
export type VariantType = RouterOutputs["card"]["getBySlug"]["variants"][0];

export enum CardSortEnum {
  NAME = "name",
  TRENDING = "trending",
  ALLTIME = "all time",
  POWER = "power",
  COST = "cost",
}

export const CARD_SORT_DEFAULT = CardSortEnum.NAME;
